import { IArcAutomationWithRuns } from '@common/interfaces/atlasai'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../../helpers/redux'
import { IAction } from '../../apiMiddleware'
import * as actions from './actions'

export interface IArcAutomationListData {
  data: IArcAutomationWithRuns[]
  total: number
}

export default combineReducers({
  list: createLoadingDataReducer<IArcAutomationListData>(
    [actions.LIST_AUTOMATIONS_REQUEST],
    [
      actions.CREATE_AUTOMATION_REQUEST,
      actions.UPDATE_AUTOMATION_REQUEST,
      actions.DELETE_AUTOMATION_REQUEST,
    ],
    true,
  ),

  selected(
    state: IArcAutomationWithRuns | null = null,
    action: IAction<IArcAutomationWithRuns>,
  ): IArcAutomationWithRuns | null {
    switch (action.type) {
      case actions.GET_AUTOMATION_SUCCESS:
        return action.data
      case actions.UPDATE_AUTOMATION_SUCCESS:
        if (state && action.data?.id === state.id) return { ...state, ...action.data }
        return state
      case actions.CLEAR_SELECTED_AUTOMATION:
      case actions.DELETE_AUTOMATION_SUCCESS:
        return null
      default:
        return state
    }
  },
})
